import React from "react";

import {
  FaExclamationTriangle,
  FaSyncAlt,
} from "react-icons/fa";

export default function SubscriptionsErrorBanner({
  title = "Une erreur est survenue",
  message,
  onRetry,
  isRetrying = false,
}) {
  if (!message) return null;

  return (
    <div className="flex flex-col gap-4 rounded-2xl border border-red-200 bg-red-50 p-4 dark:border-red-900/60 dark:bg-red-950/30 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <div className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-red-100 text-red-600 dark:bg-red-950/60 dark:text-red-300">
          <FaExclamationTriangle />
        </div>

        <div>
          <p className="font-bold text-red-800 dark:text-red-200">
            {title}
          </p>

          <p className="mt-1 text-sm text-red-700 dark:text-red-300">
            {message}
          </p>
        </div>
      </div>

      {typeof onRetry === "function" && (
        <button
          type="button"
          onClick={onRetry}
          disabled={isRetrying}
          className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-red-600 px-4 py-2.5 text-sm font-bold text-white transition hover:bg-red-700 disabled:cursor-wait disabled:opacity-60"
        >
          <FaSyncAlt
            className={
              isRetrying ? "animate-spin" : ""
            }
          />

          Réessayer
        </button>
      )}
    </div>
  );
}